/**
 * Déplacement fluide d'un marqueur entre deux positions GPS.
 *
 * Les positions arrivent toutes les quelques secondes : sans animation, le
 * camion saute. On l'interpole sur une durée courte, sauf pour qui préfère
 * moins de mouvement (`prefers-reduced-motion`) et pour les grands sauts
 * (reprise d'un signal perdu : le camion « se téléporte », ce qui est vrai).
 */
export const DUREE_DEPLACEMENT_MS = 900;
/** Au-delà de ~20 km, on saute plutôt que de faire glisser le camion à travers la carte. */
export const SAUT_MAX_DEGRES = 0.2;

export const prefereMoinsDeMouvement = () => {
  try {
    return !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch {
    return false;
  }
};

export const doitAnimer = (de, vers) => {
  if (!de || !vers) return false;
  const dLat = Math.abs(vers[0] - de[0]);
  const dLng = Math.abs(vers[1] - de[1]);
  if (dLat === 0 && dLng === 0) return false;
  return dLat <= SAUT_MAX_DEGRES && dLng <= SAUT_MAX_DEGRES;
};

export const positionIntermediaire = (de, vers, avancement) => {
  const t = Math.max(0, Math.min(1, avancement));
  return [de[0] + (vers[0] - de[0]) * t, de[1] + (vers[1] - de[1]) * t];
};

/**
 * Fait glisser `marqueur` (Leaflet) vers `vers`. Renvoie une fonction qui annule.
 * Sans animation possible, le marqueur est simplement placé.
 */
export function deplacerMarqueur(marqueur, vers, { duree = DUREE_DEPLACEMENT_MS } = {}) {
  const courant = marqueur.getLatLng();
  const de = [courant.lat, courant.lng];
  if (prefereMoinsDeMouvement() || !doitAnimer(de, vers) || typeof window.requestAnimationFrame !== 'function') {
    marqueur.setLatLng(vers);
    return () => {};
  }
  let trame = null;
  let debut = null;
  const pas = (instant) => {
    if (debut === null) debut = instant;
    const avancement = (instant - debut) / duree;
    marqueur.setLatLng(positionIntermediaire(de, vers, avancement));
    trame = avancement < 1 ? window.requestAnimationFrame(pas) : null;
  };
  trame = window.requestAnimationFrame(pas);
  return () => {
    if (trame !== null) window.cancelAnimationFrame(trame);
    trame = null;
  };
}
